"use client"

import { usePathname } from "next/navigation";

export default function Footer() {

  const pathName = usePathname();
  const isLoginScreen = pathName === "/login";

  if (isLoginScreen) return null

  return (
    <div className="w-full text-center text-black-base text-xs py-5">
      {"جميع الحقوق محفوظة. لبيه © 2024"}
    </div>
  )
}
